module.exports = __webpack_public_path__ + "img/4.8383e13e.webp";